import { getApi } from "./api_instance";

export const retrieveBids = async (p_id, dispatch) => {
  try {
    const { data } = await getApi({
      apiUrl: `/projects/api/myBids/getBidsByProject?projectId=${p_id}`,
      sendToken: true,
      dispatch,
    });
    return data;
  } catch (error) {
    throw error;
  }
};
